<!-- Tab Panels -->

@for (panel of panels; track $index; let index = $index) {
    <div
        role="tabpanel"
        tabindex="0"
        class="tab-block tab-block-{{index}} {{panel?.type | kebabCase}}"
        [id]="panel?.id | idGenerator: tabIdPrefix : parentId"
        [ngClass]="{'hidden': panel?.id !== activeTab?.id }"
        [finderScrollTo]="tabFriendlyId ? tabFriendlyId : panel?.id | idGenerator: tabIdPrefix : parentId"
        [finderScrollToId]="parentId | idGenerator: tabIdPrefix"
    >

        <ng-container>
            @switch (panel?.type) {
                @case ('imageDrawer') {
                    <!-- Image Drawer -->
                    <finder-image-drawer
                        [data]="panel.data"
                    ></finder-image-drawer>
                }

                @case ('imageBlock') {
                    <!-- Image Block -->
                    @defer {
                        <finder-image-block
                            [blockData]="panel.data"
                        ></finder-image-block>
                    }
                }

                @case ('genericText') {
                    <!-- Generic Text -->
                    <finder-generic-text
                        [data]="panel.data"
                    ></finder-generic-text>
                }

                @case ('drawer') {
                    <!-- Drawer -->
                    <finder-campaign-drawer-group
                        [groupData]="panel.data"
                    ></finder-campaign-drawer-group>
                }

                @case ('drawerGroupMultiRow') {
                    <!-- Infographic Multirow -->
                    <finder-campaign-drawer-group-multi-row
                        [groupData]="panel.data"
                        [tabChange]="tabChange"
                    ></finder-campaign-drawer-group-multi-row>
                }
            }
        </ng-container>
    </div>
}
